import CallIcon from '@mui/icons-material/Call'
import SmsIcon from '@mui/icons-material/Sms'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useContext, useEffect, useState } from 'react'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { CCPSelectButton } from './ClinicCommunicationPageComponentsAndStyles'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useParams } from 'react-router-dom'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import dayjs from 'dayjs'
import { appVersion, platformWeb } from 'src/consumer/services'
import { FCRCalendarContainer } from 'src/mentor/components/FeeCollectionReport/FeeCollectionReportStyles'
import Calendar from 'react-calendar'

const commTypes = [
  {
    id: 'clinicOff',
    label: 'Clinic Off',
    description:
      'Send notifications to patients whose next appointment falls between selected dates',
  },
]
const commMediums = [
  {
    id: 'whatsapp',
    label: 'Whatsapp',
    icon: <WhatsAppIcon />,
    description: 'Patients who registered with phone numbers get messages on whatsapp.',
  },
  {
    id: 'sms',
    label: 'SMS',
    icon: <SmsIcon />,
    description: 'Patients who registered with phone numbers get SMS.',
  },
  {
    id: 'call',
    label: 'Call',
    icon: <CallIcon />,
    description: 'Patients who registered with phone numbers get automated calls on their number.',
  },
]

export default function ClinicCommunicationsPage() {
  const todayDate = new Date()
  const oldestDate = new Date()
  oldestDate?.setMonth(todayDate?.getMonth() - 12)

  const { clinicId } = useParams()
  const { assistantData } = useContext(ClinicDataContext)

  const [communicationType, setCommunicationType] = useState()
  const [communicationMediums, setCommunicationMediums] = useState([])
  const [selectedDoctors, setSelectedDoctors] = useState([])
  const [doctorsData, setDoctorsData] = useState([])
  const [selectedDateRange, setSelectedDateRange] = useState() //{ startTime: '', endTime: '' }

  const allowedDoctors = assistantData?.clinicAssistantProfileData?.find(
    (item) => item?.clinicId === clinicId,
  )?.supportRoles

  async function getAndSetManagersProfileData() {
    if (
      Array.isArray(
        assistantData?.clinicAssistantProfileData?.find((item) => item?.clinicId === clinicId)
          ?.supportRoles,
      )
    ) {
      await assistantData?.clinicAssistantProfileData
        ?.find((item) => item?.clinicId === clinicId)
        ?.supportRoles?.forEach(async (supportRole) => {
          const response = await getCPDataWithoutParams(
            `/api/secure/clinic-assistant/service-provider?id=${
              supportRole?.managerId
            }&slug=&zoneOffset=${encodeURIComponent(
              getTimezoneOffset(),
            )}&appVersion=${appVersion}&platformType=${platformWeb}`,
          )
          if (response.status === 200) {
            setDoctorsData((prev) => [...prev, response?.data])
          }
        })
    }
  }

  useEffect(() => {
    getAndSetManagersProfileData()
  }, [assistantData])

  useEffect(() => {
    const startDateForRange = new Date()
    const endDateForRange = new Date()
    startDateForRange?.setMonth(endDateForRange?.getMonth() - 1)
    setSelectedDateRange({
      startTime: startDateForRange,
      endTime: endDateForRange,
    })
  }, [])

  console.log(assistantData)
  console.log(doctorsData)

  return (
    <>
      <ClinicHeader heading={'Clinic Communications - BETA'} />
      <div style={{ padding: '20px' }}>
        <GenericHeaderBackButton
          clickfunction={() => window.history.back()}
          styles={{ cursor: 'pointer' }}
        />
        <div style={{ marginTop: '20px' }}>
          <b>
            <u>Configure Options for sending communication</u>
          </b>
        </div>
        <div style={{ marginTop: '20px' }}>
          <b>Communication Type:</b>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            {commTypes?.map((commTypeItem, commTypeItemIndex) => {
              return (
                <CCPSelectButton
                  key={commTypeItemIndex}
                  text={commTypeItem?.label}
                  selected={commTypeItem?.id === communicationType}
                  clickAction={() => setCommunicationType(commTypeItem?.id)}
                />
              )
            })}
          </div>
        </div>
        {communicationType && (
          <div style={{ marginTop: '20px' }}>
            <b>Choose the medium(s) of communication:</b>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              {commMediums?.map((commMediumItem, commMediumItemIndex) => {
                return (
                  <CCPSelectButton
                    key={commMediumItemIndex}
                    text={commMediumItem?.label}
                    selected={communicationMediums.includes(commMediumItem?.id)}
                    icon={commMediumItem?.icon}
                    clickAction={() => {
                      if (communicationMediums.includes(commMediumItem?.id)) {
                        let newMediums = [...communicationMediums]
                        newMediums.splice(newMediums.indexOf(commMediumItem?.id), 1)
                        setCommunicationMediums(newMediums)
                      } else {
                        let newMediums = [...communicationMediums]
                        newMediums.push(commMediumItem?.id)
                        setCommunicationMediums(newMediums)
                      }
                    }}
                  />
                )
              })}
            </div>
          </div>
        )}
        {communicationType && communicationMediums?.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            <b>Choose the doctor(s) to send communication for:</b>
            <div>
              {Array.isArray(allowedDoctors) && (
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                  {allowedDoctors?.map((allowedDoctorItem, allowedDoctorItemIndex) => {
                    return (
                      <CCPSelectButton
                        key={allowedDoctorItemIndex}
                        text={
                          doctorsData?.find((item) => item?.id === allowedDoctorItem?.managerId)
                            ?.name || allowedDoctorItem?.managerId
                        }
                        selected={selectedDoctors.includes(allowedDoctorItem?.managerId)}
                        clickAction={() => {
                          if (selectedDoctors.includes(allowedDoctorItem?.managerId)) {
                            let newDoctors = [...selectedDoctors]
                            newDoctors.splice(newDoctors.indexOf(allowedDoctorItem?.managerId), 1)
                            setSelectedDoctors(newDoctors)
                          } else {
                            let newDoctors = [...selectedDoctors]
                            newDoctors.push(allowedDoctorItem?.managerId)
                            setSelectedDoctors(newDoctors)
                          }
                        }}
                      />
                    )
                  })}
                </div>
              )}
            </div>
          </div>
        )}
        {communicationType && communicationMediums?.length > 0 && selectedDoctors?.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            <b>Choose the dates for communication:</b>
            {selectedDateRange?.startTime && selectedDateRange?.endTime && (
              <div>
                <div style={{ marginBottom: '30px' }}>
                  {dayjs(selectedDateRange?.startTime, 'YYYY-MM-DD')?.format('DD MMM YYYY')}
                  (Start of day) to{' '}
                  {dayjs(selectedDateRange?.endTime, 'YYYY-MM-DD')?.format('DD MMM YYYY')}(End of
                  day)
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    alignItems: 'center',
                  }}
                >
                  <FCRCalendarContainer>
                    <Calendar
                      onChange={(nextValue) =>
                        setSelectedDateRange((prev) => ({ ...prev, startTime: nextValue }))
                      }
                      value={selectedDateRange?.startTime}
                      minDate={oldestDate}
                      maxDate={todayDate}
                      minDetail="decade"
                      showNeighboringMonth={false}
                      locale={sessionStorage.getItem('languageCode') || 'en'}
                    />
                  </FCRCalendarContainer>
                  <div>
                    <b>To</b>
                  </div>
                  <FCRCalendarContainer>
                    <Calendar
                      onChange={(nextValue) =>
                        setSelectedDateRange((prev) => ({ ...prev, endTime: nextValue }))
                      }
                      value={selectedDateRange?.endTime}
                      minDate={selectedDateRange?.startTime}
                      maxDate={todayDate}
                      minDetail="decade"
                      showNeighboringMonth={false}
                      locale={sessionStorage.getItem('languageCode') || 'en'}
                    />
                  </FCRCalendarContainer>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  )
}
